// Our main CSS
import '../css/app.css'

import { ModuleManager } from './moduleManager'
const moduleManager = new ModuleManager()// Register all modules with their selectors
moduleManager
  .register('.js-quote-slider', 'quoteSlider')
  .register('.js-logos', 'logos')
  .register('.js-feature-list', 'featureList')
  .register('.js-mobile-menu-toggle', 'mobileMenu')
  .register('.js-partners', 'partners')
  .register('.js-faq', 'faq')
  .register('.js-pricing-calculator', 'pricing-calculator')
  .register('.js-hero-lottie', 'hero-lottie')

  .registerAdmin('QuoteSlider', 'quoteSlider')
  .registerAdmin('Logos', 'logos')
  .registerAdmin('FeatureList', 'featureList')
  .registerAdmin('Partners', 'partners')
  .registerAdmin('Faq', 'faq')
  .registerAdmin('HeroLottie', 'hero-lottie')

// Initialize modules
moduleManager.init()

/**
 * 🦄: Now do your magic.
 */
